import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-modal" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "circle-bg" }
const _hoisted_4 = { class: "circle" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "header" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: "54.4rem",
    min_width: "30rem",
    centered: false,
    onClickOutside: _cache[0] || (_cache[0] = $event => ($options.close()))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Icon, {
                icon: "message-chat-circle",
                stroke: "var(--brand-500)",
                height: "2.4rem",
                width: "2.4rem"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Icon, {
              class: "pointer close",
              icon: "x-close",
              stroke: "var(--gray-400)",
              height: "2rem",
              width: "2rem",
              onClick: $options.close
            }, null, 8 /* PROPS */, ["onClick"]),
            _cache[1] || (_cache[1] = _createTextVNode(" Are you sure you want to reset your profile and restart the onboarding process? "))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "info" }, [
            _createTextVNode(" Restarting the onboarding will delete your current profile and guide you through the steps to create a new one. "),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode(" Do you want to reset your profile and start over? ")
          ], -1 /* HOISTED */))
        ])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        small: "",
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" No, keep my profile ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        small: "",
        primary: "",
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Yes, start over ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}